import { Stack } from '@mantine/core'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import cn from 'classnames'
import { TimeRange } from '@forwardflow/ui-v2'
import { IAvailabilityDay, TDay } from '@forwardflow/types/onboarding'

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const SameTime = ({
   selectedDays,
   setSelectedDays,
}: {
   selectedDays: IAvailabilityDay[]
   setSelectedDays: Dispatch<SetStateAction<IAvailabilityDay[]>>
}) => {
   const [selectedTime, setSelectedTime] = useState<[string, string]>([
      selectedDays?.[0]?.startTime ?? '09:00',
      selectedDays?.[0]?.endTime ?? '18:00',
   ])

   const onSelectDay = (day: TDay) => {
      setSelectedDays((prev) => {
         // Toggle the enabled state for the given day if it exists, otherwise add it enabled
         return prev.map((d) => {
            if (d.day !== day) return d
            return {
               ...d,
               enabled: !d.enabled,
            }
         })
      })
   }

   useEffect(() => {
      setSelectedDays((prev) => {
         return prev.map((d) => {
            return { ...d, startTime: selectedTime[0], endTime: selectedTime[1] }
         })
      })
   }, [selectedTime])

   return (
      <div className="px-8 py-6 space-y-6">
         <Stack gap={12}>
            <label className="text-white/90 font-medium text-sm">
               Select Days
            </label>
            <div className="w-full justify-between flex gap-x-4">
               {DAYS.map((day) => {
                  const isDaySelected = selectedDays?.some((d) => d.enabled && d.day === day)
                  return (
                     <div
                        key={day}
                        className={cn(
                           'px-4 py-2 rounded-2xl border border-white/10 bg-white/[0.02] flex-grow cursor-pointer',
                           {
                              '!border !border-[#A684FF] !bg-[#A684FF]/40 rounded-2xl':
                                 isDaySelected,
                           }
                        )}
                        onClick={() => onSelectDay(day as TDay)}
                     >
                        <p className="text-white/90 font-medium text-sm">
                           {day?.slice(0, 3)}
                        </p>
                     </div>
                  )
               })}
            </div>
         </Stack>
         <Stack gap={12}>
            <label className="text-white/90 font-medium text-sm">
               Select Hours
            </label>
            <TimeRange value={selectedTime} setValue={setSelectedTime} />
         </Stack>
      </div>
   )
}
